import {createAiAssistantPresentationStore} from './createAiAssistantPresentationStore';

export const aiAssistantPresentationStore = createAiAssistantPresentationStore();
